// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-1j_Ta";
var _3 = "button_outline-3aE_z";
var _4 = "button_flat-1Vndj";
var _5 = "button_text-1XzUs";
var _6 = "button_small-tpVsy";
var _7 = "button_large-3DZf1";
var _8 = "loader-2I-K5";
var _9 = "success-36pQi";
var _a = "loader_outline-3pwNO";
var _b = "loader__spinner-1iG8u";
var _c = "rotation-38Au4";
export { _1 as "__esModule", _2 as "button", _3 as "button_outline", _4 as "button_flat", _5 as "button_text", _6 as "button_small", _7 as "button_large", _8 as "loader", _9 as "success", _a as "loader_outline", _b as "loader__spinner", _c as "rotation" }
export default { "__esModule": _1, "button": _2, "button_outline": _3, "button_flat": _4, "button_text": _5, "button_small": _6, "button_large": _7, "loader": _8, "success": _9, "loader_outline": _a, "loader__spinner": _b, "rotation": _c }
